function normalizeSegments(segments = []) {
  const total = segments.reduce((sum, segment) => sum + Math.max(0, Number(segment.value || 0)), 0);

  if (!total) {
    return [];
  }

  return segments
    .filter((segment) => Number(segment.value || 0) > 0)
    .map((segment) => ({
      ...segment,
      percent: (Number(segment.value || 0) / total) * 100,
    }));
}

function DonutRing({ segments = [], center, subcenter }) {
  const normalizedSegments = normalizeSegments(segments);
  let offset = 25;

  return (
    <div className="donut-ring-wrap" aria-hidden="true">
      <svg className="donut-ring" viewBox="0 0 42 42">
        <circle className="donut-ring-track" cx="21" cy="21" r="15.915" />
        {normalizedSegments.map((segment) => {
          const dashOffset = offset;
          offset -= segment.percent;

          return (
            <circle
              key={segment.key}
              className="donut-ring-segment"
              cx="21"
              cy="21"
              r="15.915"
              stroke={segment.color}
              strokeDasharray={`${segment.percent} ${100 - segment.percent}`}
              strokeDashoffset={dashOffset}
            />
          );
        })}
      </svg>
      <div className="donut-ring-center">
        <span>{center}</span>
        {subcenter ? <small>{subcenter}</small> : null}
      </div>
    </div>
  );
}

export default function DonutMetricCard({
  title,
  value,
  subtitle,
  segments = [],
  legend = [],
  footer,
  onClick,
  tone = "default",
}) {
  const Component = onClick ? "button" : "article";

  return (
    <Component
      type={onClick ? "button" : undefined}
      className={`dashboard-kpi-card ${onClick ? "is-clickable" : ""} ${tone}`.trim()}
      onClick={onClick}
    >
      <div className="dashboard-kpi-topline">
        <span>{title}</span>
      </div>
      <div className="dashboard-kpi-body">
        {segments.length ? (
          <DonutRing segments={segments} center={value} subcenter={subtitle} />
        ) : (
          <div className="dashboard-kpi-simple">
            <strong>{value}</strong>
            {subtitle ? <span>{subtitle}</span> : null}
          </div>
        )}
      </div>
      {legend.length ? (
        <div className="dashboard-kpi-legend">
          {legend.map((item) => (
            <span key={item.key}>
              <i style={{ backgroundColor: item.color }} />
              {item.label}
            </span>
          ))}
        </div>
      ) : null}
      {footer ? <div className="dashboard-kpi-footer">{footer}</div> : null}
    </Component>
  );
}
